import React, { useEffect, useState } from "react";
import {
  requestPasswordResetToken,
  verifyPasswordResetToken,
  resetPassword,
} from "../apiPasswordReset";
import { CircularProgress, IconButton, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { useLogin } from "../api/hooks/useAuth";

import LockIcon from "@mui/icons-material/Lock";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SecurityIcon from "@mui/icons-material/Security";
import { useOrganizationSettings } from "../api/hooks/organizationSettings";
import { setOrgaizationSettings } from "../utils/storage";
import { Link } from "react-router-dom";
import LogoHeader from "../components/logoHeader";
import CustomButton from "../components/customButton";

export default function Login() {

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordResetStep, setPasswordResetStep] = useState("login"); // login, request, verify, reset
  const [resetData, setResetData] = useState({
    username: "",
    token: "",
    password: "",
    password_confirmation: "",
  });
  const loginMutation = useLogin();

  const { data, isLoading, error: organizationError } = useOrganizationSettings();


  const handleSubmit = (e) => {
    e.preventDefault();
    // Mutation for login
 
    // @ts-ignore
    loginMutation.mutate({
      username: formData.username,
      password: formData.password,
    });
  };

  useEffect(() => {
    console.log(loginMutation.error, "Login error");
  }, [loginMutation.error]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {

    console.log("we came here oooo ", isLoading);

    if (!data) return;

    console.log("we came here oooo again ", isLoading);

    setOrgaizationSettings(data.data);

    document.title = data.data.full_name;
  }, [data]);

  useEffect(() => {
    if (!organizationError) return;

    console.log("error came here oooo", organizationError);
    console.log("we came here error ", isLoading);


  }, [organizationError]);

  const handleResetDataChange = (e) => {
    setResetData({
      ...resetData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRequestReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await requestPasswordResetToken(resetData.username);
      if (response.status) {
        setSuccess(response.message || "Reset code sent successfully");
        setPasswordResetStep("verify");
      } else {
        setError(response.message || "Failed to send reset code");
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        "Failed to send reset code. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyToken = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await verifyPasswordResetToken(
        resetData.username,
        resetData.token
      );
      if (response.status) {
        setSuccess(response.message || "Token verified successfully");
        setPasswordResetStep("reset");
      } else {
        setError(response.message || "Invalid token");
      }
    } catch (err) {
      setError(
        err?.response?.data?.message || "Invalid token. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    if (resetData.password !== resetData.password_confirmation) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      const response = await resetPassword(
        resetData.username,
        resetData.token,
        resetData.password,
        resetData.password_confirmation
      );
      if (response.status) {
        setSuccess(response.message || "Password reset successfully");
        setTimeout(() => {
          setPasswordResetStep("login");
          setResetData({
            username: "",
            token: "",
            password: "",
            password_confirmation: "",
          });
          setError("");
          setSuccess("");
        }, 2000);
      } else {
        setError(response.message || "Failed to reset password");
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        "Failed to reset password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const goBackToLogin = () => {
    setPasswordResetStep("login");
    setResetData({
      username: "",
      token: "",
      password: "",
      password_confirmation: "",
    });
    setError("");
    setSuccess("");
  };

  const startPasswordReset = () => {
    setPasswordResetStep("request");
    setResetData({ ...resetData, username: formData.username });
  };

  const renderLoginForm = () => (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Username Field */}
      <div className="space-y-2">
        <label className="block text-sm font-semibold text-gray-700">
          Username
        </label>
        <div className="relative">
          <InputAdornment
            position="start"
            className="absolute left-3 top-1/2 transform -translate-y-1/2"
          >
            <AccountCircleIcon className="text-gray-200" />
          </InputAdornment>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            className="input-field pl-12"
            placeholder="Enter your username"
          />
        </div>
      </div>

      {/* Password Field */}
      <div className="space-y-2">
        <label className="block text-sm font-semibold text-gray-700">
          Password
        </label>
        <div className="relative">
          <InputAdornment
            position="start"
            className="absolute left-3 top-1/2 transform -translate-y-1/2"
          >
            <LockIcon className="text-gray-400" />
          </InputAdornment>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            className="input-field pl-12 pr-12"
            placeholder="Enter your password"
          />
          <IconButton
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 z-10"
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </div>
      </div>

      {/* Error Message */}
      {loginMutation.error && (
        <div className="p-4 bg-danger-50 border border-danger-200 rounded-xl">
          <p className="text-sm text-danger-700">
            {loginMutation.error.response?.data?.message ||
              "Something went wrong"}
          </p>
        </div>
      )}

      {/* Submit Button */}
      <button
        type="submit"
        disabled={loginMutation.isPending}
        className="w-full btn-primary py-4 text-lg font-semibold"
      >
        {loginMutation.isPending ? (
          <div className="flex items-center justify-center space-x-2">
            <CircularProgress size={20} color="inherit" />
            <span>Signing In...</span>
          </div>
        ) : (
          "Sign In"
        )}
      </button>
    </form>
  );
 
  const renderRequestResetForm = () => (
    <form onSubmit={handleRequestReset} className="space-y-6">
      <div className="space-y-2">
        <label className="block text-sm font-semibold text-gray-700">
          Email/Telephone/Account Number
        </label>
        <div className="relative">
          <InputAdornment
            position="start"
            className="absolute left-3 top-1/2 transform -translate-y-1/2"
          >
            <AccountCircleIcon className="text-gray-400" />
          </InputAdornment>
          <input
            type="text"
            name="username"
            value={resetData.username}
            onChange={handleResetDataChange}
            required
            className="input-field pl-12"
            placeholder="Enter your Email/Telephone/Account Number"
          />
        </div>
      </div>

      {error && (
        <div className="p-4 bg-danger-50 border border-danger-200 rounded-xl">
          <p className="text-sm text-danger-700">{error}</p>
        </div>
      )}

      {success && (
        <div className="p-4 bg-success-50 border border-success-200 rounded-xl">
          <p className="text-sm text-success-700">{success}</p>
        </div>
      )}

      <CustomButton isLoading={loading} label={"Send Reset Code"} onPress={handleRequestReset} />
    
    </form>
  );

  const renderVerifyTokenForm = () => (
    <form onSubmit={handleVerifyToken} className="space-y-6">
      <div className="space-y-2">
        <label className="block text-sm font-semibold text-gray-700">
          Reset Code
        </label>
        <div className="relative">
          <InputAdornment
            position="start"
            className="absolute left-3 top-1/2 transform -translate-y-1/2"
          >
            <SecurityIcon className="text-gray-400" />
          </InputAdornment>
          <input
            type="text"
            name="token"
            value={resetData.token}
            onChange={handleResetDataChange}
            required
            className="input-field pl-12"
            placeholder="Enter the 6-digit code"
            maxLength={6}
          />
        </div>
      </div>

      {error && (
        <div className="p-4 bg-danger-50 border border-danger-200 rounded-xl">
          <p className="text-sm text-danger-700">{error}</p>
        </div>
      )}

      {success && (
        <div className="p-4 bg-success-50 border border-success-200 rounded-xl">
          <p className="text-sm text-success-700">{success}</p>
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="w-full btn-primary py-4 text-lg font-semibold"
      >
        {loading ? (
          <div className="flex items-center justify-center space-x-2">
            <CircularProgress size={20} color="inherit" />
            <span>Verifying Code...</span>
          </div>
        ) : (
          "Verify Code"
        )}
      </button>
    </form>
  );

  const renderResetPasswordForm = () => (
    <form onSubmit={handleResetPassword} className="space-y-6">
      <div className="space-y-2">
        <label className="block text-sm font-semibold text-gray-700">
          New Password
        </label>
        <div className="relative">
          <InputAdornment
            position="start"
            className="absolute left-3 top-1/2 transform -translate-y-1/2"
          >
            <LockIcon className="text-gray-400" />
          </InputAdornment>
          <input
            type={showNewPassword ? "text" : "password"}
            name="password"
            value={resetData.password}
            onChange={handleResetDataChange}
            required
            className="input-field pl-12 pr-12"
            placeholder="Enter new password"
          />
          <IconButton
            onClick={() => setShowNewPassword(!showNewPassword)}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 z-10"
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {showNewPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </div>
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-semibold text-gray-700">
          Confirm New Password
        </label>
        <div className="relative">
          <InputAdornment
            position="start"
            className="absolute left-3 top-1/2 transform -translate-y-1/2"
          >
            <LockIcon className="text-gray-400" />
          </InputAdornment>
          <input
            type={showConfirmPassword ? "text" : "password"}
            name="password_confirmation"
            value={resetData.password_confirmation}
            onChange={handleResetDataChange}
            required
            className="input-field pl-12 pr-12"
            placeholder="Confirm new password"
          />
          <IconButton
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 z-10"
            size="small"
            sx={{
              position: "absolute",
              right: 8,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {showConfirmPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </div>
      </div>

      {error && (
        <div className="p-4 bg-danger-50 border border-danger-200 rounded-xl">
          <p className="text-sm text-danger-700">{error}</p>
        </div>
      )}

      {success && (
        <div className="p-4 bg-success-50 border border-success-200 rounded-xl">
          <p className="text-sm text-success-700">{success}</p>
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="w-full btn-primary py-4 text-lg font-semibold"
      >
        {loading ? (
          <div className="flex items-center justify-center space-x-2">
            <CircularProgress size={20} color="inherit" />
            <span>Resetting Password...</span>
          </div>
        ) : (
          "Reset Password"
        )}
      </button>
    </form>
  );

  const getStepTitle = () => {
    switch (passwordResetStep) {
      case "request":
        return "Request Password Reset";
      case "verify":
        return "Verify Reset Code";
      case "reset":
        return "Reset Password";
      default:
        return "Sign In";
    }
  };

  const getStepDescription = () => {
    switch (passwordResetStep) {
      case "request":
        return "Enter your username to receive a reset code";
      case "verify":
        return "Enter the 6-digit code sent to your phone";
      case "reset":
        return "Create your new password";
      default:
        return "Access your financial dashboard";
    }
  };


  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="flex items-center space-x-2">
          <CircularProgress size={20} color="inherit" />
          <span>Please wait...</span>
        </div>
      </div>
    );

  } else if (organizationError) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-primary-200/20 to-primary-300/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-200/20 to-indigo-300/20 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-purple-200/10 to-pink-200/10 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 flex min-h-screen items-center justify-center p-4">
          <div className="w-full max-w-md fintech-card p-8 animate-slide-up text-center">

            <h2 className="text-2xl font-bold text-red-600 mb-2">
              Invalid or unregistered sub-domain link.
            </h2>

            <p className="text-gray-600 leading-relaxed">
              This sub-domain is not recognized within the GBI system.<br />
              Please check the sub-domain link and try again.
            </p>

          </div>
        </div>
      </div>
    );
  } else {

    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-primary-200/20 to-primary-300/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-200/20 to-indigo-300/20 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-purple-200/10 to-pink-200/10 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 flex min-h-screen items-center justify-center p-4">
          <div className="w-full max-w-md">
            {/* Logo and Header */}
            {data && (
              <LogoHeader
                organizationName={data.data.short_name}
                organizationDescription={data.data.description}
                imageLogo={
                  data.data.customized_app_settings["customized-app-icon-url"]
                }
              />
            )}

            {/* Form Card */}
            <div className="fintech-card p-8 animate-slide-up">
              {/* Back Button for Password Reset Steps */}
              {passwordResetStep !== "login" && (
                <button
                  onClick={goBackToLogin}
                  className="flex items-center text-primary-600 hover:text-primary-800 mb-4 transition-colors duration-200"
                >
                  <ArrowBackIcon className="mr-2" />
                  Back to Login
                </button>
              )}

              <div className="text-center mb-6">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  {getStepTitle()}
                </h2>
                <p className="text-gray-500">{getStepDescription()}</p>
              </div>

              {/* Render appropriate form based on step */}
              {passwordResetStep === "login" && renderLoginForm()}
              {passwordResetStep === "request" && renderRequestResetForm()}
              {passwordResetStep === "verify" && renderVerifyTokenForm()}
              {passwordResetStep === "reset" && renderResetPasswordForm()}

              {/* Additional Links - Only show on login step */}
              {passwordResetStep === "login" && (
                <div className="mt-6 text-center space-y-3">
                  <button
                    onClick={startPasswordReset}
                    className="text-sm text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200"
                  >
                    Forgot your password?
                  </button>
                  {data &&
                    data.data.customized_app_displayable_menu_items[
                    "display-registeration-menu"
                    ] == true && (
                      <div className="text-sm text-gray-500">
                        {"Don't have an account? "}
                        <Link
                          to="/signup"
                          state={{
                            type: data.data.customized_app_displayable_menu_items[
                              "display-register-with-no-kyc-option"
                            ]
                              ? "no_kyc"
                              : "with_kyc",
                          }}
                          className="text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200"
                        >
                          Sign up here
                        </Link>
                      </div>
                    )}
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="text-center mt-8 text-sm text-gray-500">
              <p>{`© 2025 ${data.data.full_name}. All rights reserved.`}</p>
              <div className="flex items-center justify-center space-x-4 mt-2">
                <a
                  href={"https://app.gobeller.uk/customized-app/organizations/" + data.data.id + "/privacy-policy"}
                  className="hover:text-primary-600 transition-colors duration-200"
                >
                  Privacy Policy
                </a>
                <span>•</span>
                <a
                  href={"https://app.gobeller.uk/customized-app/organizations/" + data.data.id + "/privacy-policy"}
                  className="hover:text-primary-600 transition-colors duration-200"
                >
                  Terms of Service
                </a>
                <span>•</span>
                <a
                  href={"https://app.gobeller.uk/customized-app/organizations/" + data.data.id + "/delete/account"}
                  className="hover:text-primary-600 transition-colors duration-200"
                >
                  Close Account
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
